export default {"src":"/uk/_next/static/media/icon-hide.b647da72.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};